import { useEnvironmentContext } from '@openeducation/oe-it-providers';
import { hostsConfig, isDev } from '@openeducation/oe-it-services';

export const useRedirectTo = () => {
  const { environment } = useEnvironmentContext();

  return {
    redirectTo:
      !isDev && environment ? hostsConfig[environment].oldPortalUrl : undefined,
  };
};
